var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section-error",
    {
      staticClass: "row no-gutters",
      attrs: { validator: _vm.groupValidator, icon: false },
    },
    [
      _c(
        "div",
        { staticClass: "col-sm-6 col-12" },
        [
          !_vm.hideLabels
            ? _c("h6", { staticClass: "my-1 form-sub-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$tc("global.words.year", 2)) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("text-section", {
            attrs: {
              disabled: _vm.disabled,
              name: _vm.name + "-years-months",
              "class-name": "fe-num-field years " + _vm.className,
              placeholder:
                _vm.placeholderText +
                " (" +
                _vm.$t("global.phrases.inYears") +
                ")",
              label: _vm.$tc("global.words.year", 2),
              tabindex: _vm.tabindex,
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.years,
              callback: function ($$v) {
                _vm.years = $$v
              },
              expression: "years",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-6 col-12" },
        [
          !_vm.hideLabels
            ? _c("h6", { staticClass: "my-1 form-sub-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$tc("global.words.month", 2)) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("text-section", {
            attrs: {
              disabled: _vm.disabled,
              name: _vm.name + "-years-months",
              "class-name": "fe-num-field months " + _vm.className,
              placeholder:
                _vm.placeholderText +
                " (" +
                _vm.$t("global.phrases.inMonths") +
                ")",
              label: _vm.$tc("global.words.month", 2),
              tabindex: _vm.tabindex,
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.months,
              callback: function ($$v) {
                _vm.months = $$v
              },
              expression: "months",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }